import { getPlantList } from '@apis';
import { plantQueryKeys } from '@hooks';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { BaseResponse, Plant } from '@types';
import { AxiosResponse } from 'axios';

const ONE_HOUR = 1000 * 60 * 60;

const useGetPlantList = (): UseQueryResult<Plant[]> => {
  return useQuery({
    queryFn: getPlantList,
    queryKey: plantQueryKeys.list(),
    select: (response: AxiosResponse<BaseResponse<Plant[]>>) => response.data.list,
    staleTime: ONE_HOUR,
    refetchInterval: ONE_HOUR,
  });
};

export default useGetPlantList;
